import React from "react";
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from "@mui/material";
import { VideoSource } from "../../Enums/enums";
import { getPlatformFeedType } from "../../Enums/platform_constants";

export default function DuplicateSelector({ platform, selectedPlatforms, platformConfigs, value, onChange }) {
  // Any other configured platform is eligible — including one on a different feed
  // type (e.g. a PARTNER platform duplicating a SOCIAL "Edit in Video Editor"
  // render). Brand-publish scopes each queue item to one feed's platforms, but the
  // backend embeds the source platform's resolution info into the duplicate entry
  // so the same video/render resolves correctly in the other feed's queue.
  // A DUPLICATE can't point at another DUPLICATE (no chain).
  const eligible = selectedPlatforms.filter(
    (p) => p !== platform && platformConfigs[p]?.source !== VideoSource.DUPLICATE
  );

  const crossFeed =
    value && getPlatformFeedType(platform) !== getPlatformFeedType(value);

  const labelId = `dup-from-label-${platform}`;

  return (
    <FormControl fullWidth sx={{ "& .MuiSelect-select": { minHeight: 40, display: "flex", alignItems: "center", boxSizing: "border-box" } }}>
      <InputLabel id={labelId}>Duplicate from</InputLabel>
      <Select
        labelId={labelId}
        value={value || ""}
        label="Duplicate from"
        onChange={(e) => onChange(e.target.value)}
      >
        {eligible.map((p) => (
          <MenuItem key={p} value={p} sx={{ minHeight: 40 }}>
            {p}
          </MenuItem>
        ))}
      </Select>
      {eligible.length === 0 && (
        <FormHelperText>
          No other configured platform is available to duplicate from.
        </FormHelperText>
      )}
      {crossFeed && (
        <FormHelperText>
          Reuses {value}'s video/render across feed types — no separate render.
        </FormHelperText>
      )}
    </FormControl>
  );
}
